export const configurationGroupTimes = {
  timeslots: [
    {
      startTime: '13:47:00',
      endTime: '15:17:00',
      price: {
        amount: 4000,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
    {
      startTime: '14:02:00',
      endTime: '15:32:00',
      price: {
        amount: 4000,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
    {
      startTime: '14:17:00',
      endTime: '15:47:00',
      price: {
        amount: 4000,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
    {
      startTime: '14:32:00',
      endTime: '16:02:00',
      price: {
        amount: 4000,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
    {
      startTime: '14:47:00',
      endTime: '16:17:00',
      price: {
        amount: 4000,
        currencyCode: 'gbp',
      },
      quantity: 10,
      durationMinutes: 60,
    },
  ],
};
